import React, { useEffect, useMemo } from 'react';
import { ContentFrame, ScreenContainer } from '@pinwheel/origami';
import Modal from 'react-modal';
import modalOverlayStyle from '../consts/styles';
import { getModalMountNode } from '../utils';
import { TemplateContinue } from '../components/TemplateContinue';
import { ErrorImage } from '../screens/Error';
/**
 * A lightweight version of CrashPage that doesn't need any of the token or jarvis context,
 * requiring only errorMessage, and fireClientEvent. Its main usage is for errors ocurring during
 * initialization, e.g. for invalid link tokens, etc..
 *
 * @param props.error {Error} error
 * @param props.fireClientEvent {Function} fireClientEvent
 */
var CrashPage = function (props) {
    var _a = React.useState(true), open = _a[0], setOpen = _a[1];
    var linkError = useMemo(function () {
        return props.initialLinkError || {
            type: 'clientError',
            code: 'clientError',
            message: props.errorMessage || '',
            pendingRetry: false,
        };
    }, [props.initialLinkError, props.errorMessage]);
    var exit = function () {
        props.fireClientEvent('exit', {
            error: linkError,
        });
        setOpen(false);
    };
    useEffect(function () {
        if (linkError) {
            props.fireClientEvent('error', linkError);
        }
        // Intentionally only want to trigger this effect if the error changes.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [linkError]);
    return (React.createElement(Modal, { appElement: getModalMountNode(), isOpen: open, className: "modal-content", style: {
            overlay: modalOverlayStyle,
        } },
        React.createElement("div", { className: "pinwheel-link-modal" },
            React.createElement(ScreenContainer, { "data-testid": "KnownError" },
                React.createElement(ContentFrame, null,
                    React.createElement(TemplateContinue, { Image: ErrorImage, title: props.errorMessage || linkError.message, subtitle: "", buttonLabel: "Close", buttonEventId: "Error-crash", onContinue: exit, dataTestId: "KnownError-ErrorFeedback", _disableScreenTitleHeaderComponent: true }))))));
};
export default CrashPage;
